// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {connect} from 'react-redux'
import moment from 'moment'
import _ from 'lodash'

import MenuItem from '..'
import LastRefreshDate from '../../LastRefreshDate'

import {fetchMultiDRMData} from '../../../actions/multiDRM'

import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'

import './index.css'

const productsInfo = {
  ADOBE: {
    displayName: 'Adobe',
    client: 'ADOBE'
  },
  PASEO: {
    displayName: 'Paseo',
    client: 'PASEO'
  },
  WIDEVINE: {
    displayName: 'Google Widevine',
    client: 'WIDEVINE'
  },
  ITV: {
    displayName: 'VCAS Internet TV',
    client: 'InternetTV'
  },
  PLAYREADY: {
    displayName: 'Microsoft Play Ready',
    client: 'PLAYREADY'
  },
  FAIRPLAY: {
    displayName: 'Apple FairPlay Streaming',
    client: 'FAIRPLAY'
  },
}

export class MultiDRM extends Component {
  componentDidMount () {
    this.props.fetchMultiDRMData()
  }

  getNumberOfDevices = (client) => {
    if (!this.props.multiDRM.devices) {
      return 0
    }

    let {clients} = this.props.multiDRM.devices
    let devices = 0

    for (let key in clients) {
      if (key.includes(client)) {
        const validCount = parseInt(clients[key]['VALID_COUNT'], 10)
        const invalidCount = parseInt(clients[key]['INVALID_COUNT'], 10)
        devices += (validCount + invalidCount)
      }
    }
    return devices
  }

  getBuildVersion = () => {
    const {system} = this.props.multiDRM
    if (!system || !system.system) {
      return null
    }
    const regex = /\/(b.*?) /gm
    let vcas_version = regex.exec(system.system.VCAS_VERSION)[1]

    return vcas_version
  }

  getDRMMode = () => {
    const {system} = this.props.multiDRM
    if (!system || !system.system) {
      return null
    }

    return system.system.DRM_MODE
  }

  renderEmptyTable () {
    let defaultProducts = ['WIDEVINE', 'ITV', 'PLAYREADY', 'FAIRPLAY']
    let items = []

    defaultProducts.forEach(product => {
      items.push(
        <div className='tr row' key={product}>
          <div className='th col-6 col-sm-6 col-md-6 product-name'>{productsInfo[product]['displayName']}</div>
          <div className='td col-3 col-sm-3 col-md-3'><ErrorIcon className='error-icon' />&nbsp; No data found</div>
          <div className='td col-3 col-sm-3 col-md-3'><ErrorIcon className='error-icon' />&nbsp; No data found</div>
        </div>
      )
    })
    return items
  }

  renderClientStatusTableItems = () => {
    if (!this.props.multiDRM.state || this.props.multiDRM.devices === null) {
      return this.renderEmptyTable()
    }

    if (!this.props.multiDRM.state.products) {
      return this.renderEmptyTable()
    }

    let {products} = this.props.multiDRM.state

    let items = []
    for (let key in products) {
      if (key !== 'ADOBE' && key !== 'PASEO') {
        let client = productsInfo[key]['client']
        let element = (
          <div className='tr row' key={key} id={key}>
            <div className='th col-6 col-sm-6 col-md-6 product-name'>{productsInfo[key]['displayName']}</div>
            <div className='td col-3 col-sm-3 col-md-3 nowrap align-center'>&nbsp;  {products[key]['RUNNING'] ? <CheckCircleIcon className='check-icon' /> : <ErrorIcon className='error-icon' />}</div>
            <div className='td col-3 col-sm-3 col-md-3 align-center' id='device-count'>{this.getNumberOfDevices(client)}</div>
          </div>
        )
        let index = Object.keys(products).indexOf(key)
        if (index && !items[index]) {
          items[index] = element
        } else {
          items.push(element)
        }
      }
    }
    return items
  }

  renderActivityHistoryTableItems = () => {
    let {activity} = this.props.multiDRM

    if (activity && activity.events.length > 0) {
      let events = _.keyBy(activity.events, 'eventType')

      let dateFormat = 'D MMM YYYY [at][\r\n]h:mm A'

      let momentDateDevice = moment(events.CREATE_DEVICE.timestamp)
      let formattedDateDevice = momentDateDevice.format(dateFormat)

      let momentDateAsset = moment(events.CREATE_ASSET.timestamp)
      let formattedDateAsset = momentDateAsset.format(dateFormat)

      let momentDateEntitlement = moment(events.CREATE_ENTITLEMENT.timestamp)
      let formattedDateEntitlement = momentDateEntitlement.format(dateFormat)

      return (
        <div className='tr row'>
          <div className='td col-4 col-sm-4 col-md-4 align-left'>{formattedDateDevice}</div>
          <div className='td col-4 col-sm-4 col-md-4 align-left'>{formattedDateAsset}</div>
          <div className='td col-4 col-sm-4 col-md-4 align-left'>{formattedDateEntitlement}</div>
        </div>
      )
    } else {
      return (
        <div className='tr row'>
          <div className='td col-4 col-sm-4 col-md-4 align-left'><ErrorIcon className='error-icon' />&nbsp; No data found</div>
          <div className='td col-4 col-sm-4 col-md-4 align-left'><ErrorIcon className='error-icon' />&nbsp; No data found</div>
          <div className='td col-4 col-sm-4 col-md-4 align-left'><ErrorIcon className='error-icon' />&nbsp; No data found</div>
        </div>
      )
    }
  }

  renderProductStatusTable () {
    return (
      <div className='content'>
        <div className='product-detail'>
          <div className='inner-title row'>
            Service Details
          </div>
          <div className='multidrm-table product-detail-table borderless-table'>
            <div className='tbody'>
              <div className='tr row'>
                <div className='product-name td col-6 col-sm-6 col-md-6 align-right'>DRM Mode</div>
                <div className='td col-1 col-sm-1 col-md-1'>
                  {this.getDRMMode()}
                </div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div className='tr row'>
                <div className='product-name td col-6 col-sm-6 col-md-6 align-right'>VSaaS Build version</div>
                <div className='td col-1 col-sm-1 col-md-1'>
                  {this.getBuildVersion()}
                </div>
                <div className='td'></div>
                <div className='td'></div>
                <div className='td'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderClientStatusTable = () => {
    return (
      <div className='content'>
        <div className='inner-title row'>
          Client Status
        </div>
        <div className='client-activity row'>
          <div className='multidrm-table client-status-table'>
            <div className='thead'>
              <div className='tr row'>
                <div className='th product-name col-6 col-sm-6 col-md-6'></div>
                <div className='th col-3 col-sm-3 col-md-3 align-center'>Status</div>
                <div className='th align-center col-3 col-sm-3 col-md-3'>Number of devices</div>
              </div>
            </div>
            <div className='tbody'>
              {this.renderClientStatusTableItems()}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderActivityHistoryTable = () => {
    return (
      <div className='content'>
        <div className='inner-title row'>
          Client Activity
        </div>
        <div className='client-activity row'>
          <div className='multidrm-table activity-history-table'>
            <div className='thead'>
              <div className='tr row'>
                <div className='th col-4 col-sm-4 col-md-4 align-left'>Last device added</div>
                <div className='th col-4 col-sm-4 col-md-4 align-left'>Last asset added</div>
                <div className='th col-4 col-sm-4 col-md-4 align-left'>Last entitlement</div>
              </div>
            </div>
            <div className='tbody'>
              {this.renderActivityHistoryTableItems()}
            </div>
          </div>
        </div>
      </div>
    )
  }

  render () {
    const refreshDate = this.props.multiDRM.date

    return (
      <MenuItem title={'Service Availability'}>
        <div className='multi-drm'>
          <div className='row last-refresh-date'>
            <div className='col-xs-12 col-12 col-sm-12 col-md-12'>
              <LastRefreshDate date={refreshDate} />
            </div>
          </div>
          <div className='row'>
            <div className='mb-sm-3 offset-md-1 col-xs-12 col-12 col-sm-12 col-md-5'>
              {this.renderClientStatusTable()}
            </div>
            <div className='offset-md-1 col-xs-12 col-12 col-sm-12 col-md-5'>
              {this.renderActivityHistoryTable()}
            </div>
          </div>
          <div className='row'>
            <div className='offset-md-1 col-xs-12 col-sm-12 col-12 col-md-5'>
              {this.renderProductStatusTable()}
            </div>
          </div>
        </div>
      </MenuItem>
    )
  }
}


function mapStateToProps ({session, multiDRM}) {
  return {
    session: session,
    multiDRM: multiDRM
  }
}

export default connect(mapStateToProps, {fetchMultiDRMData})(MultiDRM)
